import React, { Fragment } from 'react';
import TextField from 'src/ui/library/TextField';
import TextMask from './TextMask';
import TextNumberMask from './TextNumberMask';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import DOMPurify from 'dompurify';
import intl from 'react-intl-universal';
import iconTransform from "src/helpers/iconTransform.js"
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import ErrorIcon from '@mui/icons-material/Error';

const normalizeInputValue = value => (value === null || value === undefined ? '' : String(value));

export default class NumberControl extends React.Component {
  state = {
    value: normalizeInputValue(this.props.value),
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: normalizeInputValue(this.props.value) });
    }
  }

  handleChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }

    this.setState({
      value: event.target.value,
    });
  };

  renderNumberControl() {
    const { hasError,mask } = this.props;
    const errorText = intl.get('questionnaire.showModal.alertMessageForNumber');
    const propsWithInputProps = {
      ...this.props,
      onChange: this.handleChange,
      InputProps: mask ? {
        inputComponent: TextNumberMask,
        placeholder: mask
      } :{
        inputComponent: TextMask,
        value: this.state.value,
      },
    };

    return <TextField {...propsWithInputProps} useEllipsisLabel={true} ellipsisAdjustIcon={false} hasError={hasError}
      errorText={errorText} />;
  }



  render() {

    const { align, icon, hasParentTable, showText, description, ...otherProps } = this.props;

    const alignClass = (align === "R") ?
      "right-align" : (align === "C") ?
        "center-align" : "left-align";

    const errorText = intl.get('questionnaire.showModal.alertMessageForNumber');

    let finalText = '';
    finalText = transformDisplayText(description, DEFAULT_CONTROL_FONT_SIZES[otherProps.origControlTypeName], otherProps.increaseFontSize);
    finalText = (showText === true) ? finalText : '';
    
    return <Fragment>
                <div className={`control-text flex-column  ${alignClass}`}>
                    { 
                        (finalText && !hasParentTable) ?
                        <div className={`control-wrapper ${align === "C" ? "justifyCenter" : ''}`}>
                            {icon && <div className={'control-icons control-icons-inline'}></div>}
                            <div className={'control-icons-inline-controls label-field'}>
                                <span component="legend" className="control-label">
                                    {finalText}
                                </span>
                            </div>
                        </div> :
                        null
                    }


                    {
                        <div className={`control-wrapper ${align === "C" ? "justifyCenter" : ''}`}>
                            {icon && 
                                <div className={'control-icons control-icons-inline'}>
                                    {iconTransform(icon)}
                                </div>
                            }
                            <div className={`control-icons-inline-controls ${this.props.helpText ? 'with-tooltip' : ''} ${icon ? 'with-icon' : ''}`}>       
                            { 
                                this.props.helpText ? 
                                <Fragment>
                                    <InfoTooltip
                                    toolTipText={this.props.helpText}
                                    labelText={this.renderNumberControl()}
                                    className="number-tooltip"
                                    labelClassName="number-tooltip-label" />
                                    {this.props.hasError &&
                                    <p className="textfield-error-text"> <ErrorIcon sx={{ verticalAlign:'bottom', fontSize: 14 }}/> <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(errorText) }} /></p>
                                    }
                                </Fragment>
                                : this.renderNumberControl(this.props)
                            }
                            </div>
                        </div>
                    }

                </div>
            </Fragment>
    }
}
